import React from "react";
import { Box, Typography } from "@mui/material";

const Logo = ({ size = "large", variant = "full" }) => {
  const isSmall = size === "small";
  const isMedium = size === "medium";
  
  // Bigger sizes without circle
  const logoWidth = isSmall ? 100 : isMedium ? 160 : 220;
  const logoHeight = isSmall ? 70 : isMedium ? 110 : 160;
  const fontSize = isSmall ? "1.5rem" : isMedium ? "2rem" : "3.5rem";
  const subFontSize = isSmall ? "0.6rem" : isMedium ? "0.8rem" : "1.2rem";

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          width: logoWidth,
          height: logoHeight,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          // No circle - just the image
        }}
      >
        <img
          src="/logo.png"
          alt="Worldwide Corporation"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      </Box>
      
      {variant !== "icon" && (
        <Box sx={{ textAlign: "center", mt: isSmall ? 0.5 : 1.5 }}>
          <Typography
            sx={{
              color: "#ffffff",
              fontFamily: "'Georgia', serif",
              fontWeight: "bold",
              fontSize: fontSize,
              letterSpacing: "8px",
              textTransform: "uppercase",
              textShadow: "0 2px 20px rgba(74, 144, 217, 0.2)",
            }}
          >
            WORLDWIDE
          </Typography>
          <Typography
            sx={{
              color: "#4a90d9",
              fontFamily: "'Georgia', serif",
              fontSize: subFontSize,
              letterSpacing: "12px",
              textTransform: "uppercase",
              opacity: 0.8,
              mt: -0.5,
            }}
          >
            CORPORATION
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default Logo;